import { render } from "./VisitorStats.vue?vue&type=template&id=0b5d8afb&scoped=true"
import script from "./VisitorStats.vue?vue&type=script&lang=js"
export * from "./VisitorStats.vue?vue&type=script&lang=js"

import "./VisitorStats.vue?vue&type=style&index=0&id=0b5d8afb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5d8afb"]])

export default __exports__